module.exports = "../../app/cells/components/modals/login_register_modal/show.erb";